var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElysium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#6C3CE1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 32,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 700,
    fill: "#fff"
  }, "E")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElysium);
export default __webpack_public_path__ + "static/media/elysium.bc061b6625aaa7bafcbb66d695e0efbc.svg";
export { ForwardRef as ReactComponent };